import { LastMessageTimePipe } from '../../filters/last-message-time.pipe';
import { ItemStatusComponent } from '../../components/item-status/item-status.component';
import { ItemMessageComponent } from '../../components/item-message/item-message.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import ProfilePictureService from '../../services/profile-picture.service';
import ChatService from '../../services/chat.service';
import Session from '../../utils/session.service';
import Config from '../../utils/config.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import { Input } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
	standalone: true,
	selector: 'item-chat',
	templateUrl: './item-chat.component.html',
	imports: [ CommonModule, LastMessageTimePipe, ItemStatusComponent, ItemMessageComponent, FormsModule ]
})
export class ItemChatComponent implements OnInit, OnDestroy {
	private profilePictureService: ProfilePictureService = inject(ProfilePictureService);
	private chatService: ChatService = inject(ChatService);
	private config: Config = inject(Config);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private session: Session = inject(Session);
	
	@Input() isMinimal: any | undefined;
	@Input() chat: any;
	
	vm: any = undefined;
	broadcastSubscriptions: Array<Subscription> = [];
	
	constructor() {
		this.vm = this;
		this.vm.user = this.session.getSession().user;
		this.vm.origin = this.vm.user?.origin ? this.vm.user.origin : 'siffi.com';
		this.vm.isServiceProvider = this.vm.user.businessUserType === 'SERVICE_PROVIDER';
	}
	
	ngOnInit() {
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(
				this, this.config.getBroadcastConfig().Chat.NEW_MESSAGE, (e, messages, chatId) => {
					if (chatId !== this.vm.chat.id) return;
					this.vm.chat.lastPost = messages.slice(-1).pop();
				})
		);
		
		this.vm.getProfilePictureUrl = this.profilePictureService.getProfilePictureUrl;
		this.vm.getChatBotPictureUrl = this.profilePictureService.getChatBotPictureUrl;
		this.vm.getCallingMessage = this.chatService.getCallingMessage;
	}
	
	ngOnDestroy() {
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}
	
}
